/** Where the page's phone preview looks (the tour plan §4 "Follows the selection"): an
 *  outline publishes the day its selection is in (the tour's itinerary workspace, the
 *  catalog itinerary's open day); the pane reads it while that tab is open.
 *
 *  A store, not state: the outline writes on a selection change and only the pane
 *  subscribes, so nothing else on the page re-renders. */
import { useSyncExternalStore } from 'react';

export class PreviewTarget {
  private day = 0;
  private readonly listeners = new Set<() => void>();

  getDayIndex = (): number => this.day;

  setDayIndex(index: number): void {
    if (index === this.day) return;
    this.day = index;
    for (const l of [...this.listeners]) l();
  }

  subscribe = (listener: () => void): (() => void) => {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  };
}

export function usePreviewDayIndex(target: PreviewTarget): number {
  return useSyncExternalStore(target.subscribe, target.getDayIndex);
}
